module.exports = __webpack_public_path__ + "static/media/slider-horizontal.d6332662.svg";